//admin
import "./App.css";
import React, { useState, useEffect } from "react";
import FormList from "./FormList";
//import { getToken, getFieldsList, getAccountFieldsList } from "./salesforce";

import { createForm, updateForm, getFormById } from './api'
import Select from "react-select";
import ElementDialog from "./ElementDialog";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import translateText from "./translate";
import logo from "./logo.png";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Toaster, toast } from "react-hot-toast";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  fetchFormData,
  getAccountFieldsList,
  getAccountInfo,
  getFieldsList,
  getRecordInfo,
  postToInsuranceSalesforce,
  posttoDatabase,
  sendToSalesforce,
  sendToSalesforceSign,
  updateAccountInSalesforce,
  updateRecordInSalesforce
} from "./salesforce";

const Admin = ({ consentforms, setConsentForms, nonConsentforms, setNonConsentForms, fetchFormData }) => {
  const [formsinstance, setFormsinstance] = useState([]);
  const [accountFields, setAccountFields] = useState([]);
  const [fields, setFields] = useState([]);
  const [mappingResult, setMappingResult] = useState(null);
  const [selectedFields, setSelectedFields] = useState({});
  const [addform, setAddform] = useState(true);
  const [formName, setFormName] = useState("");
  const [elementDialogVisible, setElementDialogVisible] = useState(false);
  const [elementDialogType, setElementDialogType] = useState("");
  const [currentFormId, setCurrentFormId] = useState(null);
  const [selectedOption1, setSelectedOption1] = useState(null);
  const [tempForms, settempForms] = useState([]);
  const [formElements, setFormElements] = useState([]);
  const [translatedFormElements, setTranslatedFormElements] = useState([]);
  const [elementIndex, setElementIndex] = useState(null);
  const [editform, setEditForm] = useState(false);
  const [editedElement, setEditedElement] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [dropconditional, setDropConditional] = useState(false);
  const [dropelementId, setDropElementId] = useState("");
  const [parentElementIndex, setParentElementIndex] = useState("");
  const [childElementIndex, setChildElementIndex] = useState(null);
  const [type, setType] = useState("");
  const [conditionalElementIndex, setConditionalElementIndex] = useState("");
  const [selectedConditionalOption, setSelectedConditionalOption] = useState(null);
  const [consentGiven, setConsentGiven] = useState(false);
  const [formConditional, setFormConditional] = useState(false);
  const [consentTextAreas, setConsentTextAreas] = useState([]);
  const [formConditionalvalue, setFormConditionalValue] = useState(null);
  const [user, setUser] = useState([]);
  const [profile, setProfile] = useState([]);
  const [usertoken, setUserToken] = useState(null);

  const allowedUsers = [
    'devineni.bosu1@gmail.com',
    'tkatteagummula@aptimized.com',
    'bshakthy@aptimized.com',
    'mvivek@aptimized.com',
    'brandon.bart@alliancehealthsystem.com',
    'krishnamanohar006@gmail.com',
    'john.baker@alliancehealthsystem.com'
  ];

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${codeResponse.access_token}`)
        .then((res) => {
          const userData = res.data;
          // Check if the user's email is in the allowedEmails array
          if (userData.email && allowedUsers.includes(userData.email)) {
            // If the email is allowed, set the user state
            setUser(codeResponse);
          } else {
            // If the email is not allowed or not present, display an error message
            alert('Login Failed: Unauthorized user');
          }
        })
        .catch((err) => console.error(err));
    },
    onError: (error) => alert('Login Failed: ' + error.message),
    scope: 'email'
  });
  useEffect(() => {
    if (user) {

      const userToken = localStorage.getItem("userToken");
      let tokenuser;
      if (userToken != 'undefined' && userToken !== '' && userToken !== 'null' && userToken !== null) {

        tokenuser = userToken;

        setUserToken(tokenuser);
      } else {

        setUserToken(user.access_token);
        tokenuser = user.access_token;
        localStorage.setItem('userToken', user.access_token);
      }


      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenuser}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          const userEmail = res.data.email;
          const isAllowedUser = allowedUsers.includes(userEmail);
          if (isAllowedUser) {
            setProfile(res.data);
          } else {
            //console.log("User not allowed to sign in.");
          }
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  // log out function to log the user out of google and set the profile array to null
  const logOut = () => {

    googleLogout();
    localStorage.removeItem('userToken');
    setUserToken(null);
    // setUser([]);
    // setProfile(null);
    //alert('hii')
  };
  /* 
    useEffect(() => {
      const fetchData = async () => {
        try {
          const token = await getToken();
          const objectName = 'NPP__c';
          const fieldPrefix = 'HQ';
    
          const { originalFields } = await getFieldsList(objectName, token, fieldPrefix);
          const { AccountFields } = await getAccountFieldsList('Account', token, fieldPrefix);
    
          setFields(originalFields);
          setAccountFields(AccountFields);
        } catch (error) {
          console.error('Error fetching fields:', error);
        }
      };
      fetchData();
    }, []); */

  useEffect(() => {
    const fetchData = async () => {
      try {
        const objectName = 'NPP__c';
        const fieldPrefix = 'HQ';

        const { originalFields } = await getFieldsList(objectName, fieldPrefix);
        const { accountFields } = await getAccountFieldsList('Account', fieldPrefix);
        console.log(accountFields);
        setFields(originalFields);
        setAccountFields(accountFields);
      } catch (error) {
        console.error('Error fetching fields:', error);
      }
    };
    fetchData();
  }, []);

  const openElementDialog = (elementType) => {
    setElementDialogVisible(true);
    setElementDialogType(elementType);
    //setCurrentFormId(formId);
  };

  const closeElementDialog = () => {
    setElementDialogType("");
    setElementDialogVisible(false);
    setEditedElement(null);
  };

  const addForm = () => {
    const intermediate = [
      ...(consentforms || []), // Ensure consentForms is an array
      ...(nonConsentforms || []), // Ensure nonConsentForms is an array
    ];

    settempForms([]);
    setAddform(false);
  };

  const handleSubmit = async (formId) => {
    //console.log(`Form ${formId} submitted`);
    const formData = {
      elements: tempForms
        .find((form) => form.id === formId)
        .elements.map((element) => {
          if (element.elementType === "Date Picker") {
            return {
              name: element.name,
              value: "", // You need to assign a value here, such as the current date
            };
          } else if (element.elementType === "Signature") {
            return {
              name: element.name,
              value: "", // You need to assign a value here, such as the signature data
            };
          } else {
            return {
              name: element.name,
              value: "", // You need to assign a value here based on the element type
            };
          }
        }),
    };
    try {
      await postToInsuranceSalesforce(formData);
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const handleDrop = (elementType) => {

    setDropConditional(false);
    setParentElementIndex("");
    if (
      elementType === "ConsentTextarea" ||
      elementType === "ConsentCheckbox" ||
      elementType == "PatientName And Date" ||
      elementType == "Email" ||
      elementType == "PhoneNumber" ||
      elementType == "DateOfBirth"
    ) {
      if (elementType === "ConsentTextarea") {
        var newElement = {
          id: Date.now(), // Unique identifier
          elementType: elementType,
          content: "", // Initial content
        };
      } else if (elementType === "ConsentCheckbox") {
        var newElement = {
          id: Date.now(), // Unique identifier
          elementType: elementType,
          label: "", // Initial content
        };
      }
      // Example modification inside handleDrop function
      else if (elementType == "Height Field") {
        var newElement = {
          id: Date.now(), // Ensure you have a way to generate unique IDs
          elementType: elementType,
          feet: "", // Placeholder for feet input
          inches: "", // Placeholder for inches input
          // Any other properties you need
        };
        // Logic to add newElement to the form's elements array
      } else {
        var newElement = { elementType, name: elementType };
      }
      setFormElements((formelements) => [...formelements, newElement])
      setTranslatedFormElements((formelements) => [...translatedFormElements, newElement])
    } else {
      openElementDialog(elementType);
    }
  };

  const handleDrop1 = async (elementType, elementIndex,childindex, option,type) => {
    setSelectedConditionalOption(option);
    setParentElementIndex(elementIndex);
    setChildElementIndex(childindex);
    setDropConditional(true);
setType(type);
    if (
      elementType === "ConsentTextarea" ||
      elementType === "ConsentCheckbox" ||
      elementType === "PatientName And Date" ||
      elementType === "Email" ||
      elementType === "PhoneNumber" ||
      elementType === "DateOfBirth"
    ) {
      let newElement = { id: Date.now(), elementType: elementType }; // default structure for new element

      if (elementType === "ConsentTextarea") {
        newElement.content = ""; // Initial content for text area
      } else if (elementType === "ConsentCheckbox") {
        newElement.label = ""; // Initial label for checkbox
      }

      setFormElements((prevElements) => {
        const updatedElements = prevElements.map((element, index) => {
          if (index == elementIndex) {
            if (type == "parent") {
              // Update the parent element's conditional array
              const updatedConditional = element.conditional
                ? [...element.conditional, { ...newElement, selectedConditionalOption: option }]
                : [{ ...newElement, selectedConditionalOption: option }];

              return { ...element, conditional: updatedConditional };
            } else if (type == "child" && element.conditional && element.conditional[childindex]) {
              // Update the child element's conditional array
              const updatedChildConditional = element.conditional.map((child, cIndex) => {
                if (cIndex == childindex) {
                  const updatedInnerConditional = child.conditional
                    ? [...child.conditional, { ...newElement, selectedConditionalOption: option }]
                    : [{ ...newElement, selectedConditionalOption: option }];

                  return { ...child, conditional: updatedInnerConditional };
                }
                return child;
              });

              return { ...element, conditional: updatedChildConditional };
            }
          }
          return element;
        });

        return updatedElements;
      });
      let translatedOption = await translateText(option, "es");

      // Update translatedFormElements
      setTranslatedFormElements((prevElements) => {
        const updatedTranslatedElements = prevElements.map((element, index) => {
          if (index === elementIndex) {
            if (type === "parent") {
              // Update the parent element's conditional array with translated option
              const updatedTranslatedConditional = element.conditional
                ? [...element.conditional, { ...newElement, selectedConditionalOption: translatedOption }]
                : [{ ...newElement, selectedConditionalOption: translatedOption }];
      
              return { ...element, conditional: updatedTranslatedConditional };
            } else if (type === "child" && element.conditional && element.conditional[childindex]) {
              // Update the child element's conditional array with translated option
              const updatedTranslatedChildConditional = element.conditional.map((child, cIndex) => {
                if (cIndex === childindex) {
                  const updatedInnerTranslatedConditional = child.conditional
                    ? [...child.conditional, { ...newElement, selectedConditionalOption: translatedOption }]
                    : [{ ...newElement, selectedConditionalOption: translatedOption }];
      
                  return { ...child, conditional: updatedInnerTranslatedConditional };
                }
                return child; // Return unchanged child
              });
      
              return { ...element, conditional: updatedTranslatedChildConditional };
            }
          }
          return element; // Return unchanged element
        });
      
        return updatedTranslatedElements; // Return updated translated elements array
      });

    } else {
      openElementDialog(elementType); // Presumably opens a dialog to handle other element types
    }
  };

  console.log(translatedFormElements);
  console.log(formElements);
  const editFormElement = (index, elementType, element) => {
    setElementIndex(null);
    setEditedElement(null);
    openElementDialog(elementType);
    setElementIndex(index);
    setEditedElement(element);
  };

  // Adjustments for editing conditional elements:
  const editConditionalElement = (

    parentElementIndex,
    conditionalElementIndex,
    childElementIndex,
    elementType,
    element,
    type
  ) => {
    // Prepare to edit a conditional element by setting up the necessary state:
    // You might need to set the current form, parent element index, and conditional element index
    // to correctly populate the dialog with the existing element's data.

    // Example state updates (you might need to add/set these states in your component):
    // setCurrentFormId(formId);
    setParentElementIndex(parentElementIndex);
    
    setConditionalElementIndex(conditionalElementIndex);
    
    setChildElementIndex(childElementIndex);
    // Set the element to be edited (conditional element data)
    setEditedElement(element);
    //  setDropConditional(true);
    setType(type);
    // Open the element dialog, passing the elementType to ensure the dialog knows what type of element is being edited
    openElementDialog(elementType);
  };
  console.log(translatedFormElements);
  // When submitting changes from the dialog for a conditional element,
  // ensure to update the correct element within the nested structure.
  const handleElementDialogSubmitForConditional = async (elementData) => {
    //alert("2")
    const {
      name,
      options,
      isMandatory,
      isReadOnly, // Save the state of mandatory checkbox
      validationType,
      isConditional,
      selectedConditionalOption,
    } = elementData;
    let translatedName = await translateText(name, "es");
    let translatedOptions;
    if (options) {
      translatedOptions = await Promise.all(
        options.map((option) => translateText(option, "es"))
      );
    }

    if (
      elementDialogType == "Text Field" || elementDialogType == "ConsentTextField" || elementDialogType == 'Payment' || elementDialogType == 'Address'
    ) {
      var newElement = {
        elementType: elementDialogType,
        name,
        options,
        selectedOption: selectedOption1?.value,
        isMandatory,
        isReadOnly,
        validationType,
      };
      var translatedElement = {
        elementType: elementDialogType,
        name: translatedName,
        options: translatedOptions,
        selectedOption: selectedOption1?.value,
        isMandatory,
        isReadOnly,
        validationType,
      };
    } else if (
      elementDialogType == "Checkbox" ||
      elementDialogType == "Dropdown"
    ) {
      var newElement = {
        elementType: elementDialogType,
        name,
        options,
        isMandatory,
        isReadOnly,
        isConditional,
        selectedOption: selectedOption1?.value,
      };
      var translatedElement = {
        elementType: elementDialogType,
        name: translatedName,
        options: translatedOptions,
        isMandatory,
        isReadOnly,
        isConditional,
        selectedOption: selectedOption1?.value,
      };
    } else {
      var newElement = {
        elementType: elementDialogType,
        name,
        options,
        isMandatory,
        isReadOnly,
        selectedOption: selectedOption1?.value,
      };
      var translatedElement = {
        elementType: elementDialogType,
        name: translatedName,
        options: translatedOptions,
        isMandatory,
        isReadOnly,
        selectedOption: selectedOption1?.value,
      };
    }
    // Assuming 'restOfElementData' contains the updated data for the element.

    settempForms((prevForms) => {
      return prevForms.map((form) => {
        if (form.id === currentFormId) {
          // Clone the elements array to avoid direct mutation
          let elements = [...form.elements];

          // Deep clone the parent element to avoid direct mutation
          let parentElement = { ...elements[parentElementIndex] };

          // Ensure 'conditional' array exists
          if (!Array.isArray(parentElement.conditional)) {
            parentElement.conditional = [];
          } else {
            // Clone the conditional array to avoid direct mutation
            parentElement.conditional = [...parentElement.conditional];
          }

          // Update the specific conditional element with the new data
          parentElement.conditional[conditionalElementIndex] = {
            ...parentElement.conditional[conditionalElementIndex],
            ...newElement,
          };

          // Update the parent element in the elements array
          elements[parentElementIndex] = parentElement;

          // Return the updated form
          return { ...form, elements };
        }
        return form;
      });
    });

    // Close the dialog or reset state as needed
    closeElementDialog();
  };

  // Ensure your UI components for editing conditional elements call `editConditionalElement`
  // with the correct parameters, including the formId, parentElementIndex, and conditionalElementIndex.

  const editFormElement1 = (index, elementType, formId, element) => {
    setElementIndex(null);
    setEditedElement(null);
    openElementDialog(elementType, formId);
    setElementIndex(index);
    setEditedElement(element);
  };
  const showDialog = (elementType) => {
    const name = prompt(`Enter ${elementType} name:`);
    if (!name) {
      return null;
    }
    if (
      elementType === "Checkbox" ||
      elementType === "Radio Button" ||
      elementType === "Dropdown"
    ) {
      const options = prompt(
        `Enter options for ${name} separated by commas (e.g., Option 1, Option 2):`
      );
      if (!options) {
        return null;
      }
      return {
        name,
        options: options?.split(",").map((option) => option.trim()),
      };
    }
    return { name, options: null };
  };
  const validateConsentTextareas = () => {
    for (let form of tempForms) {
      const isAllConsentFilled = form?.elements?.every((element) => {
        if (element.elementType === "ConsentTextarea") {
          return element.content && element.content.trim() !== ""; // Check that content is not empty
        }
        if (element.elementType === "ConsentCheckbox") {
          return element.label && element.label.trim() !== ""; // Check that content is not empty
        }
        return true; // If it's not a consent textarea, no need to check, so return true
      });

      if (!isAllConsentFilled) {
        alert(
          "Please fill out all consent text areas and checkbox labels before submitting the form."
        );
        return false; // Indicate that validation failed
      }
    }

    return true; // Indicate that all validations passed
  };

  const saveForms = async () => {

    if (!validateConsentTextareas()) {
      // Validation failed, do not proceed with saving
      return;
    }
    if (!formName.trim()) {
      alert("Please enter a form name");
      return;
    }
    if (
      formElements.length === 0) {
      alert("Please add at least one element to the form.");
      return;
    }

    // Determine if we are editing an existing form
    //console.log(formElements)
    var str;
    if (formConditionalvalue) {
      str = JSON.stringify(formConditionalvalue);
      //console.log(str);
    } else {
      str = null
    }
    var translatedFormName = await translateText(formName, "es")
    if (editform) {


      let updatedForm = {
        formelements: JSON.stringify(formElements),
        formelements_es: JSON.stringify(translatedFormElements),
        name_es: translatedFormName,
        name: formName,
        consent: consentGiven ? '1' : '2',
        formConditional: formConditional ? '1' : '2',
        formConditionalvalue: str
      };
      //console.log(currentFormId);
      const res = await updateForm(currentFormId, updatedForm);
      setEditForm(false);
    } else {
      let newForm;

      let Form = {
        formelements: JSON.stringify(formElements),
        formelements_es: JSON.stringify(translatedFormElements),
        name_es: translatedFormName,
        name: formName,
        consent: consentGiven,
        consent: consentGiven ? '1' : '2',
        formConditional: formConditional ? '1' : '2',
        formConditionalvalue: str
      };
      const res = await createForm(Form);
      if (res) {
        fetchFormData();
      }
      //localStorage.setItem('savedForms', JSON.stringify(forms1));


    }

    // Reset form state
    setAddform(true);
    setFormName("");
    settempForms([]);
    setFormElements([])
    setTranslatedFormElements([])
    setConsentGiven(false);
    setFormConditional(false);
    setFormConditionalValue(null);
    toast.success("operation Successfull");
  };

  /* const posttoDatabase = async (formString) => {
    try {
      console.log(formString);
      const response = await fetch('http://localhost:3002/save-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formString)
      });
      if (response.ok) {
        console.log('Form submitted successfully');
      } else {
        console.error('Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };
 */

  const editForm = async (formId) => {
    let selectedForm;
    const res = await getFormById(formId);
    // console.log(res);


    // selectedForm = forms.consentForms.find((form) => form.id === formId);
    if (res[0].consent == 1) {
      setConsentGiven(true);
    } else {
      setConsentGiven(false);
    }
    if (res[0].formConditional == 1) {
      setFormConditional(true);
    } else {
      setFormConditional(false);
    }
    if (res[0].formConditionalvalue) {
      setFormConditionalValue(JSON.parse(res[0].formConditionalvalue));
    } else {
      setFormConditionalValue(res[0].formConditionalvalue);
    }
    //settempForms([selectedForm]);
    setFormName(res[0].name);
    setCurrentFormId(res[0].id);
    let formelements = JSON.parse(res[0].formelements)
    let formelements_es = JSON.parse(res[0].formelements_es)
    setFormElements(formelements)
    setTranslatedFormElements(formelements_es)

    setAddform(false);
    setEditForm(true);
  };

  const updateElementContent = async (elementIndex, newContent) => {

    // Found the form to update
    const updatedElements = formElements.map((element, elemIndex) => {
      if (elemIndex === elementIndex) {
        // Found the element to update
        return { ...element, content: newContent };
      }

      return element;
    });

    const updatedElements1 = translatedFormElements.map(async (element, elemIndex) => {
      if (elemIndex == elementIndex) {
        // Found the element to update
        return { ...element, content: await translateText(newContent, "es") };
      }

      return element;
    });
    const results = await Promise.all(updatedElements1);
    setFormElements(updatedElements);
    setTranslatedFormElements(results);


  };

  const handleElementDialogSubmit = async (elementData) => {
    const {
      name,
      options,
      isMandatory,
      isReadOnly, // Save the state of mandatory checkbox
      validationType,
      isConditional,
      dropconditional,
      dropelementId,
      conditional,
      selectedOption2,
      readonly
    } = elementData;
    let translatedName = await translateText(name, "es");
    let newElement = {};
    let translatedElement = {};
    let translatedOptions;
    if (options) {
      translatedOptions = await Promise.all(
        options.map((option) => translateText(option, "es"))
      );
    }


    if (
      elementDialogType === "Text Field" ||
      elementDialogType === "ConsentTextField" ||
      elementDialogType === 'Payment' ||
      elementDialogType === 'Address'
    ) {
      translatedElement = {
        elementType: elementDialogType,
        name: translatedName,
        options: translatedOptions,
        selectedOption: selectedOption1?.value,
        isMandatory,
        isReadOnly,
        validationType,
        readonly
      };
      newElement = {
        elementType: elementDialogType,
        name,
        options,
        selectedOption: selectedOption1?.value,
        isMandatory,
        isReadOnly,
        validationType,
        readonly
      };
    } else if (
      elementDialogType === "Checkbox" ||
      elementDialogType === "Dropdown"
    ) {
      translatedElement = {
        elementType: elementDialogType,
        name: translatedName,
        options: translatedOptions,
        selectedOption: selectedOption1?.value,
        isMandatory,
        isReadOnly,
        isConditional,
        conditional,
      };
      newElement = {
        elementType: elementDialogType,
        name,
        options,
        selectedOption: selectedOption1?.value,
        isMandatory,
        isReadOnly,
        isConditional,
        conditional,
      };
    } else if (elementDialogType === "Height Field") {
      translatedElement = {
        elementType: elementDialogType,
        name: translatedName,
        options: translatedOptions,
        selectedOption: selectedOption1?.value,
        selectedOption2: selectedOption2?.value,
        isMandatory,
        isReadOnly,
        isConditional,
        conditional,
      };
      newElement = {
        elementType: elementDialogType,
        name,
        options,
        selectedOption: selectedOption1?.value,
        selectedOption2: selectedOption2?.value,
        isMandatory,
        isReadOnly,
        isConditional,
        conditional,
      };
    } else {
      translatedElement = {
        elementType: elementDialogType,
        name: translatedName,
        options: translatedOptions,
        selectedOption: selectedOption1?.value,
        isMandatory,
        isReadOnly,
      };
      newElement = {
        elementType: elementDialogType,
        name,
        options,
        selectedOption: selectedOption1?.value,
        isMandatory,
        isReadOnly,
      };
    }


    // alert("uuu");
    if (editedElement) {
      // Update main form elements
const updatedElements = formElements.map((element, index) => {
  if (index === elementIndex) return { ...newElement };

  if (index === parentElementIndex) {
    const updatedConditional = (element.conditional || []).map((condition, idx) => {
      if (type === "parent" && idx === conditionalElementIndex) {
        return { ...newElement, selectedConditionalOption: condition.selectedConditionalOption };
      } else if (type === "child" && condition.conditional) {
        // For child elements, update the nested conditional array
        console.log(childElementIndex);
        const updatedChildConditional = condition.conditional.map((childCond, childIdx) =>
          childIdx == childElementIndex ? { ...newElement, selectedConditionalOption: childCond.selectedConditionalOption } : childCond
        );
        return { ...condition, conditional: updatedChildConditional };
      }
      return condition;
    });
    return { ...element, conditional: updatedConditional };
  }

  return element;
});

setFormElements(updatedElements);

// Update translated elements with async handling for translations
const updatedTranslatedElements = await Promise.all(
  translatedFormElements.map(async (element, index) => {
    if (index === elementIndex) return { ...translatedElement };

    if (index === parentElementIndex) {
      const updatedConditional = await Promise.all(
        (element.conditional || []).map(async (condition, idx) => {
          if (type === "parent" && idx === conditionalElementIndex) {
            return {
              ...translatedElement,
              selectedConditionalOption: await translateText(condition.selectedConditionalOption || "", "es"),
            };
          } else if (type === "child" && condition.conditional) {
            // For child elements, update the nested conditional array
            const updatedChildConditional = await Promise.all(
              condition.conditional.map(async (childCond, childIdx) =>
                childIdx === childElementIndex
                  ? {
                      ...translatedElement,
                      selectedConditionalOption: await translateText(childCond.selectedConditionalOption || "", "es"),
                    }
                  : childCond
              )
            );
            return { ...condition, conditional: updatedChildConditional };
          }
          return condition;
        })
      );
      return { ...element, conditional: updatedConditional };
    }

    return element;
  })
);

setTranslatedFormElements(updatedTranslatedElements);

    } else {
      if (dropconditional) {
        const updatedElements = [...formElements]?.map((element, index) => {
          if (index == parentElementIndex) {
            newElement.selectedConditionalOption = selectedConditionalOption;
        
            if (type == "parent") {
              // Handle parent conditional update
              if (Array.isArray(element.conditional)) {
                element.conditional = [...element.conditional, newElement];
              } else {
                element.conditional = [newElement];
              }
            } else if (type == "child" && Array.isArray(element.conditional)) {
              // Handle child conditional update
              element.conditional = element.conditional.map((child, cIndex) => {
                if (cIndex ==childElementIndex) {
                  if (Array.isArray(child.conditional)) {
                    child.conditional = [...child.conditional, newElement];
                  } else {
                    child.conditional = [newElement];
                  }
                }
                return child;
              });
            }
          }
          return element;
        });
        
        setFormElements(updatedElements);
        
        const updatedElements1 = await Promise.all(
          [...translatedFormElements]?.map(async (element, index) => {
            if (index == parentElementIndex) {
              translatedElement.selectedConditionalOption = await translateText(selectedConditionalOption, "es");
        
              if (type == "parent") {
                // Handle parent conditional update for translated elements
                if (Array.isArray(element.conditional)) {
                  element.conditional = [...element.conditional, translatedElement];
                } else {
                  element.conditional = [translatedElement];
                }
              } else if (type == "child" && Array.isArray(element.conditional)) {
                // Handle child conditional update for translated elements
                element.conditional = await Promise.all(
                  element.conditional.map(async (child, cIndex) => {
                    if (cIndex ==childElementIndex) {
                      if (Array.isArray(child.conditional)) {
                        child.conditional = [...child.conditional, translatedElement];
                      } else {
                        child.conditional = [translatedElement];
                      }
                    }
                    return child;
                  })
                );
              }
            }
            return element;
          })
        );
        
        setTranslatedFormElements(updatedElements1);
        

      } else {
        setFormElements((elements) => [...elements, newElement]);
        setTranslatedFormElements((elements) => [...elements, translatedElement]);
      }
    }



    closeElementDialog();
  };




  const updateElementContentConditional = async (elementIndex, conditionalIndex, childIndex, conditionaltype, condition, newContent,type) => {
    // Clone the elements array to avoid direct mutation
    let elements = [...formElements];
  //alert("jj")
    // Deep clone the parent element to avoid direct mutation
    let parentElement = { ...elements[elementIndex] };
  
    // Ensure 'conditional' array exists
    parentElement.conditional = [...parentElement.conditional];
  
    if (type == "parent") {
      // Update the specific conditional element content for "parent" type
      parentElement.conditional[conditionalIndex].content = newContent;
    } else if (type == "child" && parentElement.conditional[conditionalIndex]?.conditional) {
      //alert("hii")
      // Clone the child conditional array for "child" type
      let childConditional = [...parentElement.conditional[conditionalIndex].conditional];
      childConditional[childIndex].content = newContent;
      parentElement.conditional[conditionalIndex] = { 
        ...parentElement.conditional[conditionalIndex], 
        conditional: childConditional 
      };
    }
  
    // Update the parent element in the elements array
    elements[elementIndex] = parentElement;
    
    // Clone translatedFormElements array and update based on translated content
    let transelements = [...translatedFormElements];
    let translatedParentElement = { ...transelements[elementIndex] };
    translatedParentElement.conditional = [...translatedParentElement.conditional];
  
    if (type == "parent") {
      // Update translated content for "parent" type
      translatedParentElement.conditional[conditionalIndex].content = await translateText(newContent, "es");
    } else if (type == "child" && translatedParentElement.conditional[conditionalIndex]?.conditional) {
      // Update translated content for "child" type
      let translatedChildConditional = [...translatedParentElement.conditional[conditionalIndex].conditional];
      translatedChildConditional[childIndex].content = await translateText(newContent, "es");
      translatedParentElement.conditional[conditionalIndex] = { 
        ...translatedParentElement.conditional[conditionalIndex], 
        conditional: translatedChildConditional 
      };
    }
  
    // Update translated elements in the translated array
    transelements[elementIndex] = translatedParentElement;
  
    // Set updated form elements and translated form elements
    setFormElements(elements);
    setTranslatedFormElements(transelements);
  };
  



  const updateElementLabel = async (formId, elementIndex, newLabel) => {

    const updatedElements = formElements.map((element, index) => {
      if (index === elementIndex) {
        return { ...element, label: newLabel };
      }
      return element;
    });
    setFormElements(updatedElements)
    const updatedElements1 = translatedFormElements.map(async (element, index) => {
      if (index === elementIndex) {
        return { ...element, label: await translateText(newLabel, "es") };
      }
      return element;
    });
    const results = await Promise.all(updatedElements1);
    setTranslatedFormElements(results)
  };

  const handleElementDialogSubmit1 = (elementData) => {
    const {
      name,
      options,
      isMandatory, // Save the state of mandatory checkbox
      validationType,
      isConditional,
    } = elementData;
    if (elementDialogType == "Text Field") {
      var newElement = {
        elementType: elementDialogType,
        name,
        options,
        selectedOption: selectedOption1?.value,
        isMandatory,
        validationType,
      };
    } else if (elementDialogType == "Checkbox") {
      var newElement = {
        elementType: elementDialogType,
        name,
        options,
        isMandatory,
        isConditional,
        selectedOption: selectedOption1?.value,
      };
    } else {
      var newElement = {
        elementType: elementDialogType,
        name,
        options,
        isMandatory,
        selectedOption: selectedOption1?.value,
      };
    }

    settempForms((prevForms) => {
      const updatedForms = prevForms.map((form) => {
        if (form.id === currentFormId) {
          if (editedElement) {
            const updatedElements = form.elements.map((element, index) => {
              if (index == elementIndex) {
                element = newElement;
              }
              // console.log(element);
              return element;
            });
            return {
              ...form,
              elements: updatedElements,
            };
          } else {
            return {
              ...form,
              elements: [...form.elements, newElement],
            };
          }
        }
        // console.log(form);
        return form;
      });
      return updatedForms;
    });

    closeElementDialog();
  };
  const handleFieldSelect = (selectedOption, elementName, currentForm) => {
    // console.log(selectedOption1);
    settempForms((forms) =>
      forms.map((form) => {
        if (form.id === currentForm) {
          //alert(form.id);
          //alert(currentForm);
          return {
            ...form,
            elements: form.elements.map((element) => {
              if (element.name === elementName) {
                return {
                  ...element,
                  selectedOption: selectedOption.value,
                };
              }
              return element;
            }),
          };
        }
        return form;
      })
    );
  };

  const deleteFormElement = (elementIndex) => {
    // Create a new array to avoid direct state mutation

    // Use the filter method to return a new array without the element at elementIndex
    const updatedElements = formElements.filter(
      (_, index) => index !== elementIndex
    );

    // Update the state with the new forms array
    setFormElements(updatedElements);
    const updatedElements1 = translatedFormElements.filter(
      (_, index) => index !== elementIndex
    );

    // Update the state with the new forms array
    setTranslatedFormElements(updatedElements1);
  };
  const deleteConditionalElement = (elementIndex, conditionalIndex, childConditionalIndex, type) => {
    //alert("hii")
    // Clone the element to avoid direct state mutation for `formElements`
    const updatedElement = { ...formElements[elementIndex] };
  
    if (type == 'parent') {
      // Remove the specified parent-level conditional element
      updatedElement.conditional = (updatedElement.conditional || []).filter((_, index) => index !=conditionalIndex);
    } else if (type == 'child' && updatedElement.conditional?.[conditionalIndex]?.conditional) {
      // Remove the child-level conditional element within the specified conditional array
      const parentConditional = updatedElement.conditional[conditionalIndex];
      parentConditional.conditional = (parentConditional.conditional || []).filter((_, index) => index != childConditionalIndex);
      
      // Reassign the modified conditional back to the main element
      updatedElement.conditional[conditionalIndex] = { ...parentConditional };
    }
  
    // Update formElements array
    const updatedElements = [...formElements];
    updatedElements[elementIndex] = updatedElement;
    setFormElements(updatedElements);
  
    // Repeat the same process for `translatedFormElements`
    const updatedElement1 = { ...translatedFormElements[elementIndex] };
  
    if (type == 'parent') {
      updatedElement1.conditional = (updatedElement1.conditional || []).filter((_, index) => index != conditionalIndex);
    } else if (type == 'child' && updatedElement1.conditional?.[conditionalIndex]?.conditional) {
      const parentConditional = updatedElement1.conditional[conditionalIndex];
      parentConditional.conditional = (parentConditional.conditional || []).filter((_, index) => index != childConditionalIndex);
      
      // Reassign the modified conditional back to the translated element
      updatedElement1.conditional[conditionalIndex] = { ...parentConditional };
    }
  
    // Update translatedFormElements array
    const updatedElements1 = [...translatedFormElements];
    updatedElements1[elementIndex] = updatedElement1;
    setTranslatedFormElements(updatedElements1);
  };
  

  const renderConditionalElements = (element, index,childindex,option,type) => { 
   
    return (
    
        <div
          className="droppable"
          onDrop={(event) => {
            event.stopPropagation();
            handleDrop1(

              event.dataTransfer.getData(
                "text"
              ),
              index,
              childindex,
              option,
              type
            );
          }}
          onDragOver={(event) =>
            event.preventDefault()
          }
        >
        
       
     
        {element?.conditional?.map((condition, index1) => (
          <>
            {condition.selectedConditionalOption == option && (
              <>
                {condition.elementType === "ConsentTextarea" ? (
                  <CKEditor
                    className="backConsentTextArea"
                    editor={ClassicEditor}
                    config={{
                      toolbar: [
                        "heading",
                        "|",
                        "bold",
                        "italic",
                        "blockQuote",
                        "link",
                        "numberedList",
                        "bulletedList",
                        "imageUpload",
                        "insertTable",
                        "tableColumn",
                        "tableRow",
                        "mergeTableCells",
                        "mediaEmbed",
                        "|",
                        "undo",
                        "redo",
                        "alignment:right",
                        "alignment:center",
                        "alignment:justify",
                      ],
                    }}
                    data={condition?.content || ""}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                    if(type=='parent'){
                      updateElementContentConditional(
                        index,
                        index1,
                        null,
                        condition.elementType,
                        condition,
                        data,
                        type
                      );
                    }else{
                      updateElementContentConditional(
                        index,
                        childindex,
                        index1,
                        condition.elementType,
                        condition,
                        data,
                        type
                      );
                    }
                    }}
                  />
                ) : (
                 
                  

                  <div>
                     {condition.elementType == "Checkbox" && (
                    <>
                      <div className="checkOptionsWrap">
                        {condition.options.map((option, optionIndex) => (
                          <div key={optionIndex}>
                            {optionIndex > 0 && ", "}
                            {option}
                            {condition.isConditional && renderConditionalElements(condition, index,index1,option,'child')}
                          </div>
                        ))}
                      </div>
                    </>
                  )}
{condition.elementType == "Dropdown" && (
                                  <div className="checkOptionsWrap">
                                    {condition.options.map(
                                      (option, optionIndex) => (
                                        <div key={optionIndex}>
                                          {optionIndex > 0 && ", "}
                                          {option}

                                        {condition.isConditional && renderConditionalElements(condition,index,index1,option,'child')}
                                                
                                            
                                          
                                        </div>
                                      )
                                    )}
                                  </div>
                                )}







                    <div>{condition.elementType}</div>
                    <label>{condition.name}</label>
                    {type=='parent'?(
 <button
 onClick={() =>
   editConditionalElement(
     index,
     index1,
     null ,
     condition.elementType,
     condition,
     type
   )
 }
>
 Edit
</button>


                    ):(
<button
 onClick={() =>
   editConditionalElement(
     index,
     childindex,
     index1 ,
     condition.elementType,
     condition,
     type
   )
 }
>
 Edit
</button>

                    )}
                     {type=='parent'?(
                    <button
                      onClick={() => deleteConditionalElement(index,index1,null,type)}
                    >
                      Delete Conditional
                    </button>):(
                   <button
                   onClick={() => deleteConditionalElement(index,childindex,index1,type)}
                 >
                   Delete Conditional
                 </button>
                    )}
                    {/* Recursively handle nested conditionals */}
                   {/* {condition.conditional && renderConditionalElements(condition, index1)}*/}
                  </div>
                )}
              </>
            )}
          </>
        ))}
      </div>
    );
  };
  
  return (
    <>
      <div className="header">
        <div className="imageContainer">
          <img src={logo} alt="Logo" />
        </div>
      </div>
      <div className="adminWrap">
        {usertoken != 'undefined' && usertoken != '' && usertoken != 'null' && usertoken != null ? (
          <>
            <div className="loginWrap">
              <div className="loginContainer">
                <img src={profile?.picture} alt="user image" />
                <div className="UserDetails">
                  <p>{profile?.name}</p>
                  <p> {profile?.email}</p>
                  <button onClick={logOut}>Log out</button>
                </div>
              </div>
            </div>
            <div className="rightContainer">
              <Toaster />
              <div className="addFormWrap">
                {addform ? (
                  <>
                    <h2 className="formName">Add New Form</h2>
                    <button onClick={addForm} className="addForm inlineButton">
                      Add Form
                    </button>
                  </>
                ) : (
                  <>
                    <div className="drag-and-drop-container">
                      <h2 className="headerForm">New Form</h2>
                      <div className="formContainer">
                        <div className="draggable-container">
                          <h3>Drag & Drop Fields</h3>
                          {!consentGiven ? (
                            <>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Text Field"
                                  )
                                }
                              >
                                Text Field
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData("text", "Checkbox")
                                }
                              >
                                Checkbox
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Radiobutton"
                                  )
                                }
                              >
                                Radio Button
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData("text", "Dropdown")
                                }
                              >
                                Drop down
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Date Picker"
                                  )
                                }
                              >
                                Date Picker
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "ConsentTextarea"
                                  )
                                }
                              >
                                Consent Textarea
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData("text", "Textarea")
                                }
                              >
                                Textarea
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Height Field"
                                  )
                                }
                              >
                                Height Field
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Weight"
                                  )
                                }
                              >
                                Weight Field
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "PatientName"
                                  )
                                }
                              >
                                Patient Name
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Address"
                                  )
                                }
                              >
                                Address
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Payment"
                                  )
                                }
                              >
                                Payment
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "ccdatepicker"
                                  )
                                }
                              >
                                Credit Card DatePicker
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "cctype"
                                  )
                                }
                              >
                                Credit Card Type
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Email"
                                  )
                                }
                              >
                                Email
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "PhoneNumber"
                                  )
                                }
                              >
                                Phone Number
                              </div>

                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "PatientName And Date"
                                  )
                                }
                              >
                                Patient Name And Date
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "DateOfBirth"
                                  )
                                }
                              >
                                Date Of Birth
                              </div>

                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "MultiSelectCheckbox"
                                  )
                                }
                              >
                                Multi Select Checkbox
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "ConsentTextarea"
                                  )
                                }
                              >
                                Consent Textarea
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "ConsentTextField"
                                  )
                                }
                              >
                                Consent TextField
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "ConsentCheckbox"
                                  )
                                }
                              >
                                Consent Checkbox
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Date Picker"
                                  )
                                }
                              >
                                Date Picker
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Weight"
                                  )
                                }
                              >
                                Weight Field
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Text Field"
                                  )
                                }
                              >
                                Text Field
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData("text", "Checkbox")
                                }
                              >
                                Checkbox
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Address"
                                  )
                                }
                              >
                                Address
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "PatientName"
                                  )
                                }
                              >
                                Patient Name
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Email"
                                  )
                                }
                              >
                                Email
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "PhoneNumber"
                                  )
                                }
                              >
                                Phone Number
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "PatientName And Date"
                                  )
                                }
                              >
                                Patient Name And Date
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "DateOfBirth"
                                  )
                                }
                              >
                                Date Of Birth
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Payment"
                                  )
                                }
                              >
                                Payment
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "ccdatepicker"
                                  )
                                }
                              >
                                Credit Card DatePicker
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "cctype"
                                  )
                                }
                              >
                                Credit Card Type
                              </div>



                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "MultiSelectCheckbox"
                                  )
                                }
                              >
                                Multi Select Checkbox
                              </div>
                              <div
                                className="draggable"
                                draggable="true"
                                onDragStart={(event) =>
                                  event.dataTransfer.setData(
                                    "text",
                                    "Signature"
                                  )
                                }
                              >
                                Signature
                              </div>
                              <h4>ShortCodes</h4>
                              <p>$Name</p>
                              <p>$InsuranceCompany</p>
                              <p>$Input</p>
                            </>
                          )}
                        </div>


                        <div className="form-container">
                          <h3>
                            Form Name:
                            <input
                              type="text"
                              placeholder="Enter Form Name"
                              value={formName}
                              onChange={(e) => setFormName(e.target.value)}
                            />
                          </h3>
                          <h3>
                            <input
                              type="checkbox"
                              id="consentCheckbox"
                              checked={consentGiven}
                              onChange={(e) =>
                                setConsentGiven(e.target.checked)
                              }
                            />
                            <label htmlFor="consentCheckbox">Consent</label>
                          </h3>
                          <h3>
                            <input
                              type="checkbox"
                              id="consentCheckbox"
                              checked={formConditional}
                              onChange={(e) => {
                                if (!e.target.checked) {
                                  setFormConditionalValue(null)
                                }
                                setFormConditional(e.target.checked)
                              }
                              }
                            />
                            <label htmlFor="consentCheckbox">FormConditional</label>

                            {formConditional && (
                              <Select
                                value={formConditionalvalue}
                                onChange={(selectedOption) => {
                                  setFormConditionalValue(selectedOption);
                                  //setSelectedField(selectedOption.value);
                                  //const selectedFieldData = fields.find((field) => field.name === selectedOption.value);
                                  //setOptions(selectedFieldData ? selectedFieldData.picklistValues.map(value => value.label) : []);
                                }}
                                options={fields.map(option => ({ value: option.name, label: option.name?.replace(/^HQ_|__c$|__s$/g, '') }))}
                                isSearchable={true}
                                placeholder={`Select value for form...`}
                              />



                            )}
                          </h3>
                          <div
                            className="droppable"
                            onDrop={(event) =>
                              handleDrop(

                                event.dataTransfer.getData("text")
                              )
                            }
                            onDragOver={(event) => event.preventDefault()}
                          >
                            {formElements.map((element, index) => (
                              <div
                                key={index}
                                className="fieldContainer"
                                style={{ border: "1px solid #ccc" }}
                              >
                                <div className="elementWrap">
                                  <label className="elementType">
                                    Element Name : {element.name}
                                  </label>
                                  <div className="elementName">
                                    {" "}
                                    Element Type : {element.elementType}
                                  </div>
                                </div>
                                <div className="formActions">
                                  {(!consentGiven ||
                                    element.elementType !=
                                    "ConsentTextarea" ||
                                    element.elementType !=
                                    "ConsentCheckbox") && (
                                      <button
                                        onClick={(e) =>
                                          editFormElement(
                                            index,
                                            element.elementType,

                                            element
                                          )
                                        }
                                      >
                                        Edit
                                      </button>
                                    )}

                                  <button
                                    onClick={() =>
                                      deleteFormElement(index)
                                    }
                                  >
                                    Delete
                                  </button>
                                </div>
                                {element.elementType == "ConsentTextarea" && (
                                  <>
                                    <CKEditor
                                      className='backConsentTextArea'
                                      editor={ClassicEditor}
                                      config={{

                                        toolbar: [
                                          "heading",
                                          "|",
                                          "bold",
                                          "italic",
                                          "blockQuote",
                                          "link",
                                          "numberedList",
                                          "bulletedList",
                                          "imageUpload",
                                          "insertTable",
                                          "tableColumn",
                                          "tableRow",
                                          "mergeTableCells",
                                          "mediaEmbed",
                                          "|",
                                          "undo",
                                          "redo",
                                          "alignment:right",
                                          "alignment:center",
                                          "alignment:justify"
                                        ],
                                      }}
                                      data={element?.content || ""}
                                      onReady={(editor) => {
                                        console.log('Editor is ready to use!', editor);
                                        // setEditorInstance(editor);
                                      }}
                                      onChange={(event, editor) => {
                                        if (editor && editor.model) {
                                          const data = editor.getData();
                                          updateElementContent(

                                            index,
                                            data
                                          )
                                        }
                                      }}
                                    />
                                  </>

                                )}

                                {element.elementType == "ConsentCheckbox" && (
                                  <>
                                    <input type="checkbox" />
                                    <textarea
                                      value={element.label}
                                      onChange={(e) =>
                                        updateElementLabel(

                                          index,
                                          e.target.value
                                        )
                                      }
                                      placeholder="Edit Consent Label"
                                    />
                                  </>
                                )}

                                {element.elementType === "Text Field" && (
                                  <></>
                                )}
                                {element.elementType ==
                                  "MultiSelectCheckbox" && (
                                    <>
                                      <div className="checkOptionsWrap">
                                        {element.options.map(
                                          (option, optionIndex) => (
                                            <div key={optionIndex}>
                                              {optionIndex > 0 && ", "}
                                              {option}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </>
                                  )}

                                {element.elementType === "Checkbox" && (
                                  <>
                                    <div className="checkOptionsWrap">
                                      {element.options.map(
                                        (option, optionIndex) => (
                                          <div key={optionIndex}>
                                            {optionIndex > 0 && ", "}
                                            {option}
                                           
                                              <>
                                                {element.isConditional && renderConditionalElements(element,index,null,option,'parent')}
                                                </>
                                            
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </>
                                )}
                                {element.elementType === "Radiobutton" && (
                                  <div>
                                    {element.options.map(
                                      (option, optionIndex) => (
                                        <div key={optionIndex}>
                                          {optionIndex > 0 && ", "}
                                          {option}
                                        </div>
                                      )
                                    )}
                                  </div>
                                )}
                                {element.elementType == "Dropdown" && (
                                  <div className="checkOptionsWrap">
                                    {element.options.map(
                                      (option, optionIndex) => (
                                        <div key={optionIndex}>
                                          {optionIndex > 0 && ", "}
                                          {option}

                                         
                                           
                                              <>
                                                {element.isConditional && renderConditionalElements(element,index,null,option,'parent')}
                                                </>
                                            
                                          
                                        </div>
                                      )
                                    )}
                                  </div>
                                )}

                                {element.elementType === "Signature" && (
                                  <div
                                    key={index}
                                    style={{ border: "1px solid #ccc" }}
                                  >
                                    <div className="elementWrap">
                                      <label className="elementType">
                                        {" "}
                                        Field Name{element.name}
                                      </label>
                                      <div className="elementname">
                                        Field Type{element.elementType}
                                      </div>
                                    </div>
                                    <button
                                      onClick={(e) =>
                                        editFormElement(
                                          index,
                                          element.elementType,

                                          element
                                        )
                                      }
                                    >
                                      Edit
                                    </button>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>


                        <button onClick={saveForms} className="saveForm">
                          Save Form
                        </button>
                      </div>
                    </div>
                    {elementDialogVisible && (
                      <ElementDialog
                        elementType={elementDialogType}
                        onSubmit={handleElementDialogSubmit}
                        elementDialogVisible={elementDialogVisible}
                        setElementDialogVisible={setElementDialogVisible}
                        selectedFields={selectedFields}
                        currentFormId={currentFormId}
                        fields={fields}
                        accountFields={accountFields}
                        handleFieldSelect={handleFieldSelect}
                        selectedOption1={selectedOption1}
                        setSelectedOption1={setSelectedOption1}
                        editedElement={editedElement}
                        setEditedElement={setEditedElement}
                        dropconditional={dropconditional}
                        dropelementId={parentElementIndex}
                        onSubmit1={handleElementDialogSubmitForConditional}
                        selectedConditionalOption={selectedConditionalOption}
                      />
                    )}
                  </>
                )}
              </div>

              <FormList
                consentforms={consentforms}
                setConsentForms={setConsentForms}
                nonConsentforms={nonConsentforms}
                setNonConsentForms={setNonConsentForms}
                editForm={editForm}
                settempForms={settempForms}
                posttoDatabase={posttoDatabase}
                fetchFormData={fetchFormData}
              />
            </div>
          </>
        ) : (
          <div className="adminLoginWrap">
            <div className="borderWrap">
              <h2>Sign in</h2>
              <button onClick={login}>Sign in with Google </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Admin;